import { trackingEvent } from '@notino/web-tracking';

import { dispatchEcommerceMessage } from '../../../messagingService';
import { EcommerceSectionNamespace } from '../../model';

export const trackOrderAsLastTimePageViewEvent = (referrer: string) => {
  dispatchEcommerceMessage(
    trackingEvent({
      event: EcommerceSectionNamespace.EEcommerceEvent.PAGE_VIEW,
      page: {
        path: EcommerceSectionNamespace.EEcommercePageViewPath.ORDER_AS_LAST_TIME,
        title: EcommerceSectionNamespace.EEcommercePageViewTitle.ORDER_AS_LAST_TIME,
        type: EcommerceSectionNamespace.EEcommercePageViewType.ORDER_AS_LAST_TIME,
        unified_name: EcommerceSectionNamespace.EEcommercePageViewUnifiedName.ORDER_AS_LAST_TIME,
        referrer,
      },
      _clear: true,
    }),
  );
};
